export const NUMBER_CONTROL_RANK = 3;
export const BOOLEAN_CONTROL_RANK = 3;
export const MULTISELECT_CONTROL_RANK = 4;
export const ENUM_CONTROL_RANK = 3;
export const SELECT_CONTROL_RANK = 4;
export const DATE_CONTROL_RANK = 4;
export const LAYOUT_RANK = 2;
export const LAYOUT_ARRAY_RANK = 2;
export const LAYOUT_CATEGORIZATION_RANK = 2;
export const LAYOUT_GROUP_RANK = 2;
export const LAYOUT_HORIZONTAL_RANK = 2;
export const LAYOUT_STEPPER_RANK = 3;
export const LAYOUT2COLUMNS_RANK = 2;
export const INVISIBLE_CONTROL_RANK = 5;
